import React from "react";
import canadaMap from "../assets/image/Canada_map.png";
import { MapPin } from "lucide-react";

const MapWithMarker = () => {
  return (
    <div className="relative w-full h-screen overflow-hidden">
      <img
        src={canadaMap}
        alt="Canada Map"
        className="w-full h-full object-contain opacity-100 fixed top-0 left-0 z-0 pointer-events-none"
      />

      <div
        className="absolute z-10 text-red-700 animate-bounce"
        style={{
          top: "68%",
          left: "57%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <MapPin size={30} strokeWidth={0} fill="red" />
      </div>
    </div>
  );
};

export default MapWithMarker;
